import { useParams } from "react-router-dom";
import Input from "../../../components/form/input";
import Template from "../../../template/template";
import useInitPage from "../../../utils/initPage";
import Aside from "../aside/aside";
import t from "../../../i18n/i18n";
import useApi from "../../../services/api";
import { useState } from "react";
import Notify from "../../../components/notification/notify";
import { validateEmail } from "../../../utils/validations";
import { handleApiErrors } from "../../../utils/handleErrors";
import { useDispatch } from "react-redux";
import { UpdateUser } from "../../../store/reducers/auth.reducer";

const ChangeEmail = () => {
  useInitPage({ title: "" });
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const dispatch = useDispatch();

  const { token } = useParams();

  const { ApiChangeEmail } = useApi();

  const [form, setForm] = useState({});

  function handleInputChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function submitForm(e) {
    e.preventDefault();
    setSubmitDisabled(true);

    if (!form.newEmail) {
      Notify({ type: "danger", message: t("Errors.EmptyEmail") });
      setSubmitDisabled(false);

      return;
    }

    if (form.newEmail !== form.newEmailConfirmation) {
      Notify({ type: "danger", message: t("Errors.InvalidEmailConfirmation") });
      setSubmitDisabled(false);

      return;
    }

    if (!validateEmail(form.newEmail)) {
      Notify({ type: "danger", message: t("Errors.InvalidEmail") });
      setSubmitDisabled(false);

      return;
    }

    const { data } = await ApiChangeEmail(token, { newEmail: form.newEmail });

    if (data.errors) {
      handleApiErrors(data.errors);
      setSubmitDisabled(false);

      return;
    }

    Notify({ type: "success", message: t("Success.EmailChanged") });

    dispatch(UpdateUser(data));

    setTimeout(() => {
      window.location.replace("/");
    }, 800);
  }

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="inside-warp">
              <div className="col-sidebar">
                <div className="mobile-side-btn">
                  <button type="button" className="side-toggle">
                    <i className="fal fa-cog"></i>
                  </button>
                </div>
                <div className="sidebar-main">
                  <Aside />
                </div>
              </div>

              <div className="col-contentbar">
                <div className="user-profile-form social-regester-warp">
                  <div className="form-col profile-form ">
                    <h1 className="text-uppercase">{t("ChangeEmail.Title")}</h1>
                    <form onSubmit={submitForm}>
                      <Input
                        label={t("ChangeEmail.NewEmail")}
                        name="newEmail"
                        value={form.newEmail || ""}
                        onChange={handleInputChange}
                        type="text"
                      />
                      <Input
                        label={t("ChangeEmail.NewEmailConfirmation")}
                        name="newEmailConfirmation"
                        value={form.newEmailConfirmation || ""}
                        onChange={handleInputChange}
                        type="text"
                      />

                      <div className="submit-btn no-border">
                        <button disabled={submitDisabled} type="submit" className="btn-regester">
                          {t("ChangeEmail.ButtonSubmit")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
};

export default ChangeEmail;
